import React, { useState } from "react";

const AddCaseDetails = ({ check }) => {
  const data = JSON.parse(localStorage.getItem("data"));
  const advocate_id = JSON.parse(localStorage.getItem("advocateId"));
  const client_id = JSON.parse(localStorage.getItem("clientId"));

  const [formData, setFormData] = useState({
    case_name: "",
    case_description: "",
    comment: "",
    date: new Date().toISOString().split('T')[0],
    documents: null
  });

  const [alert, setAlert] = useState({
    show: false,
    message: "",
    type: ""
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [id]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prevState => ({
      ...prevState,
      documents: e.target.files[0]
    }));
  };

  const handleReset = () => {
    setFormData({
      case_name: "",
      case_description: "",
      comment: "",
      date: new Date().toISOString().split('T')[0],
      documents: null
    });

    // Clear the alert after resetting
    setAlert({ show: false, message: "", type: "" });
  };

  const Alert = ({ message, type }) => (
    <div
      style={{
        padding: "12px 20px",
        marginBottom: "20px",
        borderRadius: "4px",
        backgroundColor: type === "success" ? "#d4edda" : "#f8d7da",
        color: type === "success" ? "#155724" : "#721c24",
        border: `1px solid ${type === "success" ? "#c3e6cb" : "#f5c6cb"}`,
        position: "fixed",
        top: "20px",
        right: "20px",
        zIndex: 9999,  // Ensure it is higher than other elements
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        minWidth: "300px",
      }}
    >
      {message}
    </div>
  );

  const handleSubmit = async () => {
    try {
      if (!formData.case_name.trim()) {
        setAlert({
          show: true,
          message: "Please enter a case name",
          type: "error"
        });
        return;
      }

      const formPayload = new FormData();
      formPayload.append('case_name', formData.case_name);
      formPayload.append('case_description', formData.case_description);
      formPayload.append('advocate', advocate_id);
      formPayload.append('client', client_id);
      if (formData.documents) {
        formPayload.append('documents', formData.documents);
      }

      const response = await fetch('https://admindashboard.clns.in/api/adv-client/cases/', {
        method: 'POST',
        body: formPayload,
      });

      if (response.status === 201) {
        const result = await response.json();
        console.log('Case created successfully:', result);
        
        setAlert({
          show: true,
          message: "Case created successfully!",
          type: "success"
        });

        handleReset();

        // Reset the alert after 3 seconds
        setTimeout(() => {
          setAlert({ show: false, message: "", type: "" });
        }, 3000);
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to create case');
      }

    } catch (error) {
      console.error('Error creating case:', error);
      
      setAlert({
        show: true,
        message: "Failed to create case. Please try again.",
        type: "error"
      });

      setTimeout(() => {
        setAlert({ show: false, message: "", type: "" });
      }, 3000);
    }
  };

  return (
    <div
      className="add-case-details"
      style={{
        padding: "24px",
        backgroundColor: "#f7f7f7",
        border: "1px solid #e5e5e5",
        borderRadius: "8px",
        fontFamily: "Arial, sans-serif",
        fontSize: "14px",
        color: "#333",
      }}
    >
      {alert.show && <Alert message={alert.message} type={alert.type} />}

      <div
        className="add-case-from-consulted-cases"
        style={{
          marginBottom: "24px",
        }}
      >
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            marginBottom: "16px",
          }}
        >
          Add Case from consulted cases or Search Phone no. to create New Case
        </h3>
        <div
          className="lawyer-client-info"
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "24px",
          }}
        >
          <div
            className="lawyer-info"
            style={{
              flex: "1",
              marginRight: "16px",
            }}
          >
            <label
              htmlFor="lawyer-phone-number"
              style={{
                display: "block",
                marginBottom: "8px",
              }}
            >
              Lawyer Phone Number
            </label>
            <input
              type="text"
              id="lawyer-phone-number"
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                marginBottom: "16px",
              }}
              value={data?.advocateNumber}
              disabled
            />
            <div
              className="lawyer-details"
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fff",
                padding: "12px",
                borderRadius: "4px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
            >
              <div
                className="lawyer-image"
                style={{
                  marginRight: "12px",
                }}
              >
                <img
                  src="/lawyer-avatar.png"
                  alt="Criminal Lawyer"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                />
              </div>
              <div
                className="lawyer-advocate-name"
                style={{
                  marginRight: "8px",
                }}
              >
                {data.advocateName}
              </div>
              <div
                className="lawyer-branch"
                style={{
                  marginRight: "8px",
                }}
              >
                {data.advocateLocation}
              </div>
              <div
                className="lawyer-phone"
                style={{
                  marginRight: "8px",
                }}
              >
                {data.advocateNumber}
              </div>
            </div>
          </div>
          <div
            className="client-info"
            style={{
              flex: "1",
              marginLeft: "16px",
            }}
          >
            <label
              htmlFor="client-phone-number"
              style={{
                display: "block",
                marginBottom: "8px",
              }}
            >
              Client Phone Number
            </label>
            <input
              type="text"
              id="client-phone-number"
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                marginBottom: "16px",
              }}
              disabled
              value={data.clientNumber}
            />
            <div
              className="client-details"
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fff",
                padding: "12px",
                borderRadius: "4px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
            >
              <div
                className="client-image"
                style={{
                  marginRight: "12px",
                }}
              >
                <img
                  src="/client-avatar.png"
                  alt="Client"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                />
              </div>
              <div
                className="client-name"
                style={{
                  fontWeight: "bold",
                  marginRight: "8px",
                }}
              >
                {data.clientName}
              </div>
              <div
                className="client-branch"
                style={{
                  marginRight: "8px",
                }}
              >
                {data.clientLocation}
              </div>
              <div
                className="client-phone"
                style={{
                  marginRight: "8px",
                }}
              >
                {data.clientNumber}
              </div>
            </div>
          </div>
        </div>

        <div
          className="case-name"
          style={{
            marginBottom: "24px",
          }}
        >
          <label
            htmlFor="case_name"
            style={{
              display: "block",
              marginBottom: "8px",
            }}
          >
            Case Name
          </label>
          <input
            type="text"
            id="case_name"
            value={formData.case_name}
            onChange={handleInputChange}
            style={{
              width: "100%",
              padding: "8px 12px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </div>

        <div
          className="case-summary"
          style={{
            marginBottom: "24px",
          }}
        >
          <label
            htmlFor="case_description"
            style={{
              display: "block",
              marginBottom: "8px",
            }}
          >
            Case Description
          </label>
          <textarea
            id="case_description"
            value={formData.case_description}
            onChange={handleInputChange}
            style={{
              width: "100%",
              padding: "8px 12px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              resize: "vertical",
              minHeight: "80px",
            }}
          />
        </div>

        <div
          className="attach-documents"
          style={{
            marginBottom: "24px",
          }}
        >
          <label
            htmlFor="documents"
            style={{
              display: "block",
              marginBottom: "8px",
            }}
          >
            Attach Documents
          </label>
          <input
            type="file"
            id="documents"
            onChange={handleFileChange}
            style={{
              backgroundColor: "#fff",
              padding: "8px 12px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "100%",
            }}
          />
        </div>

        <div
          className="case-date"
          style={{
            marginBottom: "24px",
          }}
        >
          <label
            htmlFor="date"
            style={{
              display: "block",
              marginBottom: "8px",
            }}
          >
            Date
          </label>
          <input
            type="date"
            id="date"
            value={formData.date}
            onChange={handleInputChange}
            style={{
              padding: "8px 12px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </div>

        <div
          className="case-event-comment"
          style={{
            marginBottom: "24px",
          }}
        >
          <label
            htmlFor="comment"
            style={{
              display: "block",
              marginBottom: "8px",
            }}
          >
            Comment for Event purpose by this first event can auto create with
            create case
          </label>
          <textarea
            id="comment"
            value={formData.comment}
            onChange={handleInputChange}
            style={{
              width: "100%",
              padding: "8px 12px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              resize: "vertical",
              minHeight: "80px",
            }}
          />
        </div>

        <div
          className="actions"
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={handleReset}
            className="reset-btn"
            style={{
              backgroundColor: "#f0f0f0",
              color: "#333",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "8px",
            }}
          >
            Reset
          </button>
          <button
            onClick={handleSubmit}
            className="create-case-btn"
            style={{
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Create Case
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCaseDetails;
